// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2525":"be67d2bf3c8928c1","5685":"66d40326ef3a5320","7778":"beb76beb7ecda251","9133":"beb76beb7ecda251"}[chunkId] + ".css";
};